module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "primary",
    attrs: {
      "id": "content"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "xs": 4,
      "lg": 4
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 6,
      "lg": 8
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "auto"
    },
    attrs: {
      "src": ""
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 6,
      "lg": 3
    }
  }), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 6,
      "lg": 6
    }
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin": "auto",
      "background-color": "#FFFFFF",
      "text-align": "center",
      "border-radius": "6px",
      "box-shadow": "0 3px 4px 0 rgba(0,0,0,0.15)"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "45%",
      "padding": "30px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-family": "Helvetica-Bold",
      "color": "#333333",
      "font-size": "24px",
      "letter-spacing": "0",
      "line-height": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._v("Log in.")]), _vm._v(" "), _c('Form', {
    ref: "formInline",
    attrs: {
      "model": _vm.formInline,
      "rules": _vm.ruleInline,
      "inline": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "prop": "userName"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "size": "large",
      "placeholder": "Username/E-mail"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formInline')
      }
    },
    model: {
      value: (_vm.formInline.userName),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "userName", $$v)
      },
      expression: "formInline.userName"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-person-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "margin-top": "6px"
    },
    attrs: {
      "prop": "passWord"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "password",
      "size": "large",
      "placeholder": "Password"
    },
    on: {
      "on-enter": function($event) {
        return _vm.handleSubmit('formInline')
      }
    },
    model: {
      value: (_vm.formInline.passWord),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "passWord", $$v)
      },
      expression: "formInline.passWord"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "ios-locked-outline"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Checkbox', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#747D82",
      "letter-spacing": "0",
      "line-height": "18px"
    },
    model: {
      value: (_vm.isSaveUser),
      callback: function($$v) {
        _vm.isSaveUser = $$v
      },
      expression: "isSaveUser"
    }
  }, [_vm._v("Remember me")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#41B8BC",
      "letter-spacing": "0",
      "line-height": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.findPassword
    }
  }, [_vm._v("Forgot password?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('FormItem', [_c('Button', {
    staticStyle: {
      "width": "200px",
      "background": "#41B8BC",
      "margin-top": "6px"
    },
    attrs: {
      "loading": _vm.loading
    },
    on: {
      "click": function($event) {
        return _vm.handleSubmit('formInline')
      }
    }
  }, [(!_vm.loading) ? _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#FFFFFF",
      "line-height": "12px"
    }
  }, [_vm._v("LOGIN")]) : _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#FFFFFF",
      "line-height": "12px"
    }
  }, [_vm._v("LOGIN...")])])], 1)], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#747D82",
      "letter-spacing": "0",
      "line-height": "18px"
    }
  }, [_vm._v("Don’t have an account?")]), _vm._v("     \n                            "), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-family": "Helvetica",
      "font-size": "12px",
      "color": "#41B8BC",
      "letter-spacing": "0",
      "line-height": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.gotoRegister
    }
  }, [_vm._v("Sign up")])], 1)])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 2,
      "lg": 3
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('Modal', {
    attrs: {
      "title": "Enter Two-factor Authentication Code",
      "align": "center",
      "loading": _vm.authLoading
    },
    model: {
      value: (_vm.loginAuthenticationModal),
      callback: function($$v) {
        _vm.loginAuthenticationModal = $$v
      },
      expression: "loginAuthenticationModal"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Enter the code generated by your Google Authenticator app.")]), _vm._v(" "), _c('Form', {
    ref: "formAuthentication",
    attrs: {
      "model": _vm.formAuthentication,
      "rules": _vm.ruleAuthentication,
      "inline": ""
    }
  }, [_c('FormItem', {
    staticStyle: {
      "margin-top": "6px",
      "width": "200px"
    },
    attrs: {
      "prop": "randomCode"
    }
  }, [_c('Input', {
    staticClass: "juzhong",
    staticStyle: {
      "width": "100px",
      "height": "30px",
      "text-align": "center",
      "margin-top": "20PX"
    },
    attrs: {
      "type": "text",
      "placeholder": "000000",
      "size": "large",
      "maxlength": 6
    },
    model: {
      value: (_vm.formAuthentication.randomCode),
      callback: function($$v) {
        _vm.$set(_vm.formAuthentication, "randomCode", $$v)
      },
      expression: "formAuthentication.randomCode"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('FormItem', {
    attrs: {
      "prop": "authenticationSecret"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formAuthentication.authenticationSecret),
      expression: "formAuthentication.authenticationSecret"
    }],
    attrs: {
      "type": "hidden",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.formAuthentication.authenticationSecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formAuthentication, "authenticationSecret", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Please contact our "), _c('a', {
    attrs: {
      "href": "####"
    }
  }, [_vm._v("customer service")]), _vm._v(" if you've lost access to your Google Authenticator app.")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.modalCancel
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.submitRandomCode('formAuthentication')
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311fdfe7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/Login.vue
// module id = 427
// module chunks = 0